import { Component, OnInit } from '@angular/core';
import { DocumentService } from '../../services/document.service';
import { LoginService } from '../../services/login/login.service';
import { Document } from '../../models/document';
import { Router } from '@angular/router';

import { Store } from '@ngrx/store';
import * as fromRoot from '../../common/appstore/index';
import * as layout from '../../common/appstore/actions';

@Component({
  selector: 'listdocument',
  templateUrl: './listdocument.component.html',
  styleUrls: ['./listdocument.component.scss']
})
export class ListdocumentComponent implements OnInit {

  documents: Document[] = [];
  step = 0;

  constructor(
    private servicedocument: DocumentService,
    private servicelogin: LoginService,
    private router: Router,
    private store: Store<fromRoot.AppState>
  ) { }

  ngOnInit() {
    this.getListDocument();
  }

  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
  }

  getListDocument() {
    let currentuser = this.servicelogin.getUser();

    /*this.store.select(fromRoot.getLayoutState).subscribe(docs => {
      if (!docs.listdocuments) {
        this.servicedocument.getListDocuments(currentuser.id).subscribe((document: Document[]) => {
          this.documents = document;
        });
      } else {
        this.documents = docs.listdocuments;
      }
    });*/
  }

  goToDoc(document: any) {
    this.store.dispatch(new layout.AddDocument(document));
    this.store.dispatch(new layout.AddSociete(document.societe));
    this.store.dispatch(new layout.AddSignataire(document.societe.signataire));
    this.servicedocument.createDocument(document);
    this.router.navigate(['cdc-steps', document.type]);
  }



}



// WEBPACK FOOTER //
// C:/Users/Quentin/projets/kontractor/src/app/components/listdocument/listdocument.component.ts